import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// The Woodsy Craft Co. — New-customers campaign (adc_dn2k9wvnm5). Real lifetime
// aggregates from ANALYTICS.ADS_SNAPSHOTS.MANAGER_METRICS_CAMPAIGN_PERIODS.
// Monthly series lives in realBrandData.ts. The budget is the platform's
// standing recommendation; reported budgets stop after Apr 2026.
export const campWcNew: FaireAdCampaignEntity = {
  token: "camp_wc_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_woodsy_craft",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 310,
  startedRunningAt: "2024-10-23",
  segmentMetrics: {
    numCustomersAcquired: 17,
    salesDollars: 11435,
    totalAdsSpendDollars: 1874,
    cpaDollars: 110,
    bestEstimateSalesDollars: 11435,
    bestEstimateRoas: 6.1,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-20T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
